import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { APP_ROUTES, setToken, useAppDispatch, useAppSelector, userManager } from "@/utils";

const OAuthCallbackPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const redirectUrl = useAppSelector((state) => state.loginRedirect.redirectUrl);
  const navigate = useNavigate();

  useEffect(() => {
    userManager
      .signinRedirectCallback()
      .then((res) => {
        if (res) {
          setToken.forAll(dispatch, res.access_token);
          const wantedUrl = (res.state as any)?.wantedUrl;
          const wantedSearchParams = (res.state as any)?.wantedSearchParams;
          if (wantedUrl) {
            navigate(`${wantedUrl}${wantedSearchParams || ""}`);
            return;
          }
          if (redirectUrl) {
            navigate(redirectUrl);
            return;
          }
          navigate(APP_ROUTES.home.overview.url);
        }
      })
      .catch(() => {
        // navigate(APP_ROUTES.login.url)
      });
  }, [dispatch, navigate, redirectUrl]);

  return null;
};

export default OAuthCallbackPage;
